__turbopack_context__.v({
  "fireworksCanvas": "fireworks-module__oYC9jW__fireworksCanvas",
  "fireworksFadeOut": "fireworks-module__oYC9jW__fireworksFadeOut",
});
